import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues } from '@dbk-legacy/muster/utils';
import { find, remove } from 'lodash';
import format from 'date-fns/format';
import getTime from 'date-fns/get_time';
import isValidJsonString from '../utils/is-valid-json-string';
import { NOTIFICATION_TYPE } from '../constants';
import { encode } from 'base-64';
import Guid from '../utils/guid';


export default () =>muster()
    .path('notifications.getUserNotifications', {
      call: async ({ req }, { get, set, call }) => {
        let [roleId] = await getValues(get(['cioinsights.roles']));
        if(!roleId){
          roleId="notifications";
        }
        const [loginValueWithTZ] = await getValues(get(['auth.lastSessionTZ']));
        // const [lastLoginValue] = await getValues(get(['auth.lastSession']));
        const formattedValue = format(getTime(loginValueWithTZ), 'YYYY-MM-DDTHH:mm:ssZ');
        
        const [oReturn] = await getValues(get(`roster.data.notifications.getUserNotifications["${roleId}"]["${formattedValue}"]`));

        isValidJsonString(oReturn).then((data) => {
          const updated = {
            ...data,
            totalDisplay: data.total,
          };
          set('notifications.userNotifications', updated);
        });
      },
    })
    .path('notifications.getSettings', {
      call: async ({ req }, { get, set, call }) => {
        const guidStr = Guid();
        const [oReturn] = await getValues(get(`roster.data.notifications.getUserPrefNotifications["${guidStr}"]`));
        await Promise.all([set('notifications.showSpinner', true)]);
        isValidJsonString(oReturn).then(async (data) => {
          const [entitlement] = await getValues(get('auth.entitlement'));
          if(!entitlement.esign_regular_customer){
             const found = find(data, { alertType:NOTIFICATION_TYPE.esignature, value: 'T'});
             if(found){
              remove(data, (n) => n.alertType === NOTIFICATION_TYPE.esignature);
             }
          }

          set('notifications.settings', data);
          set('notifications.showSpinner', false);
        });
      },
    })
    .path('notifications.saveSettings', {
      call: async ({ req }, { get, set, call }) => {
        const settings = req.args[0];
        const settingsStr = encode(JSON.stringify(settings));
        const guidStr = Guid();
        const [oReturn] = await getValues(get(`roster.data.notifications.saveUserPrefNotifications["${settingsStr}"]["${guidStr}"]`));



        isValidJsonString(oReturn).then((data) => {
          if (data.saveSuccess) {
            // alert('Notification Settings successfully saved');
            // call('ui.history.push', { pathname: '/profile' }, true);
            //set('app.user.cacheId', Date.now());
          }
        });
      },
    })
    .path('notifications.markedAsRead', {
      call: async ({ req }, { get, set, call }) => {
        const [oReturn] = await getValues(get('roster.data.notifications.markedAsRead'));

        isValidJsonString(oReturn).then(async (data) => {
          if (data.readSuccess) {
            /* marked-as-read is successfull */
            const [notifications] = await getValues(get('notifications.userNotifications'));
            const [isNotificationDisabledForRM] = await getValues(get('auth.isNotificationDisabledForRM'));
            let updated;
            if(isNotificationDisabledForRM){
               updated = {
                ...notifications
              };
            }else{
               updated = {
                ...notifications,
                totalDisplay: 0,
              };
           }
            await set('notifications.userNotifications', updated);
          }
        });
      }
    })
    .path('notifications.userNotifications', variable({}))
    .path('notifications.settings', variable())
    .path('notifications.showSpinner', variable(true))
